import { useEffect } from 'react'
import { useAuth } from '@/context/auth-context'

/**
 * Hook to listen for auth state changes
 * This is now a simple wrapper around the Auth Context
 * and doesn't rely on Redux anymore
 */
function useAuthStateListener() {
  const { user, isAuthenticated } = useAuth()

  useEffect(() => {
    // Authentication status tracking
    // No logging needed in production
  }, [user])

  return { isAuthenticated }
}

export default useAuthStateListener
